/**
 * Navigation utility functions for the Creative system
 *
 * Flat 4-tab model: displayUnits | displayGroups | videoUnits | videoGroups
 * RESTful URLs:     /creatives/display/units?page=1
 */

import { CREATIVE_ROUTE_CONFIG } from '../config/routeConfig';

/**
 * Safely parse URL search parameters
 */
export const getURLParam = (search, key, defaultValue = '') => {
  try {
    return new URLSearchParams(search).get(key) || defaultValue;
  } catch {
    return defaultValue;
  }
};

/**
 * Parse pathname into clean segments
 */
export const parsePathParts = (pathname) => {
  return pathname.split('/').filter(Boolean);
};

/**
 * Get detail paths using RESTful pattern
 * @param {string} entityType - 'unit', 'adunit', 'group', or 'adgroup'
 * @param {string} mediaType - 'DISPLAY' or 'VIDEO'
 * @returns {string} RESTful path
 */
export const getDetailPath = (entityType, mediaType = 'DISPLAY') => {
  const mediaTypePath = mediaType === 'VIDEO' ? 'video' : 'display';
  const normalized = entityType.toLowerCase();
  const entityTypePath = (normalized === 'adunit' || normalized === 'unit') ? 'units' : 'groups';

  return `/creatives/${mediaTypePath}/${entityTypePath}`;
};

/**
 * Validate route parameters
 */
export const validateRouteParams = (tab, _subtab, pageNumber) => {
  const isTab = CREATIVE_ROUTE_CONFIG.validTabs.includes(tab);
  const isValidPage = pageNumber > 0;

  return {
    isValidTab: isTab,
    isValidSubtab: isTab,
    isValidPage,
    isValid: isTab && isValidPage,
  };
};
